import { HiOutlineHome, HiOutlineUsers, HiCalendar } from "react-icons/hi";
import { TbUsers, TbFileInvoice, TbFileReport, TbZip } from "react-icons/tb";
import { FaRegCalendarAlt, FaDochub, FaCalendarWeek } from "react-icons/fa";
import { MdFolderZip, MdHealthAndSafety, MdListAlt } from "react-icons/md";
import { FaUserDoctor } from "react-icons/fa6";
import { AiOutlineSetting } from "react-icons/ai";
import { RiMedicineBottleLine, RiUserHeartLine } from "react-icons/ri";
import { TbMedicineSyrup, TbDental } from "react-icons/tb";
import { File, FileArchiveIcon } from "lucide-react";
import { ManageAccounts, Report } from "@mui/icons-material";
import { GiPapers, GiZipper } from "react-icons/gi";
import { BsFileZip } from "react-icons/bs";
import { BiFolder } from "react-icons/bi";

const SidebarConfig = {
  superadmin: [
    {
      title: "sidebar.dashboard",
      path: "/superadmin",
      icon: HiOutlineHome,
    },
    {
      title: "sidebar.clinics",
      path: "/superadmin/clinics",
      icon: TbUsers,
    },
    {
      title: "sidebar.appointments",
      path: "/superadmin/appointments",
      icon: FaRegCalendarAlt,
    },
  ],
  admin: [
    {
      title: "sidebar.dashboard",
      path: "/admin",
      icon: HiOutlineHome,
    },
    {
      title: "sidebar.patients",
      path: "/admin/patients",
      icon: TbUsers,
    },
    {
      title: "sidebar.appointments",
      path: "/admin/appointments",
      icon: FaRegCalendarAlt,
    },
    {
      title: "sidebar.staff",
      path: "/admin/staff",
      icon: HiOutlineUsers,
    },
    // {
    //   title: "sidebar.schedule",
    //   path: "/admin/schedule",
    //   icon: FaRegCalendarAlt,
    //   feature: "schedule",
    // },
    {
      title: "sidebar.payments",
      path: "/admin/payments",
      icon: MdListAlt,
      feature: "payments",
    },
    {
      title: "sidebar.invoices",
      path: "/admin/invoices",
      icon: TbFileInvoice,
      feature: "invoices",
    },

    {
      title: "sidebar.services",
      path: "/admin/services",
      icon: TbDental,
    },
    {
      title: "sidebar.products",
      path: "/admin/products",
      icon: TbMedicineSyrup,
      feature: "products",
    },
    {
      title: "sidebar.healthform",
      path: "/admin/healthformbuilder",
      icon: MdHealthAndSafety,
    },
    {
      title: "sidebar.reports",
      path: "/admin/reports",
      icon: BiFolder,
      feature: "reports",
    },
    // {
    //   title: "sidebar.suppliers",
    //   path: "/admin/suppliers",
    //   icon: BiFolder,
    //   feature: "suppliers",
    // },
    {
      title: "sidebar.settings",
      path: "/admin/settings",
      icon: AiOutlineSetting,
    },
  ],
  doctor: [
    {
      title: "sidebar.dashboard",
      path: "/doctor",
      icon: HiOutlineHome,
    },
    {
      title: "sidebar.patients",
      path: "/doctor/patients",
      icon: TbUsers,
    },
    {
      title: "sidebar.appointments",
      path: "/doctor/appointments",
      icon: FaRegCalendarAlt,
    },

    {
      title: "sidebar.settings",
      path: "/doctor/settings",
      icon: AiOutlineSetting,
    },
  ],
  reception: [
    {
      title: "sidebar.dashboard",
      path: "/receptionist",
      icon: HiOutlineHome,
    },
    {
      title: "sidebar.patients",
      path: "/receptionist/patients",
      icon: TbUsers,
    },
    {
      title: "sidebar.appointments",
      path: "/receptionist/appointments",
      icon: FaRegCalendarAlt,
    },
    {
      title: "sidebar.doctors",
      path: "/receptionist/doctors",
      icon: FaUserDoctor,
    },
    // {
    //   title: "sidebar.schedule",
    //   path: "/receptionist/schedule",
    //   icon: FaRegCalendarAlt,
    //   feature: "schedule",
    // },
    {
      title: "sidebar.payments",
      path: "/receptionist/payments",
      icon: MdListAlt,
      feature: "payments",
    },
    {
      title: "sidebar.invoices",
      path: "/receptionist/invoices",
      icon: TbFileInvoice,
      feature: "invoices",
    },
    {
      title: "sidebar.settings",
      path: "/receptionist/settings",
      icon: AiOutlineSetting,
    },
  ],
  finance: [
    {
      title: "sidebar.dashboard",
      path: "/finance",
      icon: HiOutlineHome,
    },
    {
      title: "Payments",
      path: "/payments",
      icon: MdListAlt,
    },
    {
      title: "invoice.title",
      path: "/invoices",
      icon: TbFileInvoice,
    },
    {
      title: "sidebar.settings",
      path: "/settings",
      icon: AiOutlineSetting,
    },
  ],
};

// Function to retrieve menu items for a specific role
export const getSidebarForRole = (role) => SidebarConfig[role] || [];

export default SidebarConfig;
